export const chapter1 = [

    //page 1
    'A lone warrior walks a dusty dirt road under the sun,',
    'It has been many months since his journey had begun,',
    'He had travelled far from his homeland on his quest,',
    'He marches on despite his body yearning for rest,',
    'His armour clinks in rhythm as he walks on,',
    'His mind wanders through the days now gone,',
    'With the help of friends through battle bound,',
    'An ancient relic of his home was finally found,',
    'The enchanted hammer weighed heavy in his hands,',
    'Now obtained despite evil‘s long crafted plans,',
    'Above the fields and trees some white clouds peppered the sky, ',
    'The rural air was sweet and fresh, but his mouth was dry,',

    //page 2
    'The faintest of din entered his perception,',
    'He scanned for anyone through every direction,',
    'A pack mule came into view followed by another,',
    'Soon a whole baggage train emerged from behind cover,',
    'A few dozen merchants, some well laden wagons, ',
    'Just a few of guards with their hands swinging flagons,',
    'The warrior offered a wave to those far ahead,',
    'Despite his efforts they ignored him instead,',
    'The steel-clad man‘s pace had now slowed to a walk,',
    'He‘d been a while without company, he felt like a talk,',
    '“Where are you heading? Are you travelling the north pass?”',
    'He hollered and hoped they would talk to him at last,',
    'A single merchant turned and offered a friendly smile,',
    '“Yes“ he called “we‘ve come up from the south a few miles”,',
    'And with that, he nodded and continued on,',
    'The rear guard glared like he didn‘t belong,',
    'They plodded along through the heat of noon,',
    'Everyone wishing for their destination soon,',
    'He watched as they left his view into the forest of pines,',
    'The mountains bore closer, and the path began to wind,',
    'His gaze fell to his feet as he trudged up the path,',
    'For a moment he thought he heard someone laugh,',

    //page 3
    'The wind turned and leaves blew through the trees,',
    'It became clear it was a scream caught on the breeze,',
    'His heart began to beat quickly in his chest, ',
    'He doubted the few guards he saw were the best,',
    'The warrior shed his heavy pack and ran ahead at full steam,',
    'More screams rung out and he knew what that must mean,',
    'The ambushers had chosen the perfect spot,',
    'The warrior feared that they would kill the lot,',
    'He pumped his legs harder and faster but with little gain,',
    'Every passing second someone cried out in pain,',
    'He struggled with his decision for a moment or four,',
    'Reluctantly, he dropped the heavy hammer to the floor,',
    'He cringed as it bounced off a rock and landed into the mud,',
    'Unburdened, he powered up the path each step now a thud,',
    'The warrior finally rounded the tree obscuring his view,',
    'The slaughter before him took his breath then two,',
    'The merchants lay on the ground in puddles all broken,',
    'Vacant eyes stared at the sky of who he had just spoken,',
    'Their assailants were creatures the warrior had not seen,',
    'A mixture of pig, rat, the size of a man and very mean,',
    'Long claws, fangs and wielding crude blades of steel,',
    'Some of the fallen had become their afternoon meal,',

    //page 4
    'A thick line of orange spines and fur ran down their backs,',
    'They were ravenous but not the sharpest of tacks,',
    'The smaller ones were taking everything of value and more,',
    'The bigger ones were fighting and let out a furious roar,',
    'The warrior charged forward his trusty short sword in hand,',
    'A quick slash lopped off a beast’s head, he didn‘t see it land,',
    'He dashed into the fray and called to those still in the fight,',
    '“Hold fast!” and a break in the clouds bathed him in light,',
    'Upon seeing the warrior cleave through the evil pack,',
    'They rallied and began to push the creatures back,',
    'A large beast dropped a carcase he was about to chew,',
    'And with a leap and a swipe nearly cut him in two,',
    'The warrior parried his attack with expert skill,',
    'He gutted a smaller beast then went in for the kill,',
    '“You‘re next!” he stated as he brought down his blade,',
    'But this creature was crafty and began to evade,',
    'With a duck and lunge he bit into his shoulder,',
    'The warrior lost his footing and tripped on a boulder,',
    'The beast scrambled over, eager to devour his next victim, ',
    'But the warrior drew a dagger launched it into his sternum,',
    'It clasped at the wound, blood soaking his fur increasingly red,',
    'The warrior got to his feet and quickly stabbed him untill dead,',

    //page 5
    'A pair of large creatures let out a loud howling cry,',
    'They couldn‘t get there quick enough to see the warrior die,',
    'The warrior eyed them up and gave his blade a twist,',
    'He flicked the blood from it “You‘re next on my list!”',
    'They collided together in a messy exchange of blows,',
    'One foe dropped, and the warrior took a solid hit to his nose,',
    'A fighting snarl found familiar lines upon his face,',
    'He bared his teeth as his blood spilt all over the place,',
    'The beast looked around and found no other his size,',
    'It was determined to take the steel-clad man‘s head as his prize,',
    'It launched a flurry of swipes with its savage weapon,',
    'The counter and stab showed the warrior just outmatched him,',
    '“Gut ‘em all!” He roared as he strode forward like Death‘s preacher,',
    'The lone standing guard joined him dispatching the closest creature,',
    'The remaining beasts scrambled upon seeing their defeat,',
    'Many were cut down as the blades swung on repeat,',
    '“Victory is ours!” the guard called, relief flooding his bruised face,',
    'A wounded beast began to crawl away, but not according to his mace,',
    'He dislodged his weapon from the carcass and raised it high,',
    'The two men were the only ones who refused to die,',
    'They roared a defiant shout into the surrounding trees,',
    'Now spent, the guard dropped to his knees,',

    //page 6
    '“What is your name? I am Eanom, I owe you my life,”',
    '“Call me Sigg,” the warrior replied as his picked up his knife,',
    '“See if anyone else made it, I‘ll be right back,”',
    'Sigg sheathed his blade and jogged down the track.',
    'Not long after, he found the mud and the rock,',
    'The enchanted hammer now gone to his shock,',
    'Sigg desperately searched the surrounding mud and plants,',
    'With no luck he returned to Eanom uttering frustrated rants,',
    'Eanom sat next to an injured merchant who lay bleeding,',
    '“Hold on!” He commanded as he saw him conceding,',
    'Sigg ran over and they bound up his wounds tight,',
    '“We need to get him out of here while it‘s still light”,',
    'Eanom nodded, “I‘ll see if I can find one of the mules nearby”,',
    'Sigg held the injured man‘s hand and looked him in the eye,',
    '“Think upon your loving family, and your close friends”,',
    '“Now use that as fuel to stave off the end”,',
    'The man opened a bruised eye and managed a small nod,',
    'A moment later Eanom and a donkey did plod,',
    '“Is he the only one left alive? I was hoping for more”,',
    'Eanom shook his head slowly “Fallen to tooth and claw”,',
    '“Beasts that set ambushes as well as take loot?”, ',
    '“I must find who pulls the strings of these brutes”,',

    //page 7
    '“Let us talk of such things with our heads under a roof”,',
    'Sigg nodded, and they continued up the track boot and hoof,',
    'A distant howl made them pick up the pace,',
    'They hoped to cover more ground before they gave chase,',
    'The donkey and injured man complained with grunts alike,',
    'Not one of them was looking forward to the hike,',
    'But press on they did, up and over the slope,',
    'At the peak, the sight of the village filled them with hope,',
    'Now downhill, they had some breath spare for words,',
    'The danger had passed according to the singing birds,',
    '“These roads were safe last time I was here some months back”,',
    'Eanom shrugged “This knowledge was something we both lack”,',
    '“So are you some sort of knight? What order are you from?”,',
    '“I‘m a WarScholar, from Cragknoll” Sigg tapped his heart like a drum.',
    '“I don‘t know either, but I‘m just a lowly town guard,”',
    '“You can‘t be like scholars I know like that all scarred,”',
    '“I have books, but my focus is battle and noting what wins one,”',
    '“It seems your town might need me before we‘re done,”',
    '“Tell me of those beasts, have you fought them before?”',
    '“No, until today I thought they were just folklore,”',
    '“Spine-backs I think they call them; they eat kids that misbehave”,',
    '“I certainly did not think they‘d be the cause of so many a grave”,',

    //page 8
    'Eanom lowered his head and focused on the path,',
    'Sigg knew that feeling and channelled his wrath,',
    'They trudged on and their eyes locked on the village ahead,',
    'Sigg yearned for tall walls, fire, a roof and a bed,',

];